<div *ngIf="loading"
     class="container-loading-content is-flex is-justify-content-center is-align-items-center">
  <div class="loading"></div>
</div>
<div *ngIf="!loading">
  <p *ngIf="orders.length==0" class="txt ">Für diesen Account wurden noch keine Bestellungen getätigt.</p>
  <div *ngIf="orders.length != 0">
    <div class="my-3">
      <iw-shop-core-paginator [start]="start" [limit]="limit" [length]="length" (onChange)="changePage($event)"></iw-shop-core-paginator>
    </div>
    <div class="columns is-marginless container-item is-multiline mt-2" *ngFor="let item of orders; let i = index;">
      <div class="column py-1 is-6-mobile is-3-tablet">
        <p class="subtitle has-text-weight-bold">{{item.dateCreated | date:'dd.MM.yyyy HH:mm'}} </p>
      </div>
      <div class="column py-1 is-6-mobile is-3-tablet">
          @if (userService.hasLoggedInUserAccess({ type: 'prices', customerId: customerId ?? '' })) {
        <p class="subtitle has-text-weight-bold"
           *ngIf="item.priceMode == 'net'">{{NumberFormat(item.sum.total.netTotal, currency)}}</p>
        <p class="subtitle has-text-weight-bold"
           *ngIf="item.priceMode == 'gross'">{{NumberFormat(item.sum.total.grossTotal, currency)}}</p>
          }
      </div>
      <div class="column is-6-tablet is-hidden-mobile"></div>
      <div class="column  py-1 is-12-mobile is-3-tablet">
        <span class="tag" [class]="getOrderStatusColor(item.status) + ' order-status'">{{getOrderStatusTranslation(item.status)}}</span>
        <p class="subtitle has-text-weight-bold mt-2">{{item.count.articles.items}} Artikel</p>
      </div>
      <div class="column py-1 is-12-mobile is-3-tablet">
        <p>Bestell-Nr.: {{item.id}}</p>
      </div>
      <div class="column is-12-mobile is-12-tablet is-6-desktop container-buttons">
        <div class="columns">
          <div class="column is-6">
            <div class="get-order-details">
              <iw-shop-forms-submit-button   submitLabel="Bestelldetails" classes="is-light" (submit)="showOrderConfirmation(item.id)" [formStatus]="(item.loadingConfirmation) ? 'loading' : null"></iw-shop-forms-submit-button >
            </div>
          </div>
          <div class="column is-6">
            <div class="put-order-to-cart">
              <iw-shop-forms-submit-button   (submit)="putOrderToCart(item.id)" submitLabel="Nochmal bestellen" [formStatus]="(item.loadingPutOrderToCart) ? 'loading' : null"></iw-shop-forms-submit-button >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="my-3">
      <iw-shop-core-paginator [start]="start" [limit]="limit" [length]="length" (onChange)="changePage($event)"></iw-shop-core-paginator>
    </div>
  </div>
</div>

<div *ngIf="orderConfirmation" class="modal is-active">
  <div class="modal-background"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Bestellbestätigung</p>
      <button class="delete" (click)="closeOrderConfirmation()"></button>
    </header>
    <section class="modal-card-body">
      <iframe [src]="orderConfirmation"></iframe>
    </section>
  </div>
</div>




